import { lazy, Suspense } from "react";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Home from "./pages/Home";

const NotFound = lazy(() => import("./pages/NotFound"));
const LightPreview = lazy(() => import("./pages/LightPreview"));
const DubaiLandingPage = lazy(() => import("./pages/DubaiLandingPage"));
const AiOptimizationPage = lazy(() => import("./pages/AiOptimizationPage"));
const ShopifyMetaAdsPage = lazy(() => import("./pages/ShopifyMetaAdsPage"));
const MetaAdsDubaiPage = lazy(() => import("./pages/MetaAdsDubaiPage"));

function RouteFallback() {
  return <main className="min-h-screen bg-[#080C14]" aria-busy="true" aria-label="Seite wird geladen" />;
}

const NotFoundRoute = () => <Suspense fallback={<RouteFallback />}><NotFound /></Suspense>;
const LightPreviewRoute = () => <Suspense fallback={<RouteFallback />}><LightPreview /></Suspense>;
const DubaiLandingPageRoute = () => <Suspense fallback={<RouteFallback />}><DubaiLandingPage /></Suspense>;
const AiOptimizationPageRoute = () => <Suspense fallback={<RouteFallback />}><AiOptimizationPage /></Suspense>;
const ShopifyMetaAdsPageRoute = () => <Suspense fallback={<RouteFallback />}><ShopifyMetaAdsPage /></Suspense>;
const MetaAdsDubaiPageRoute = () => <Suspense fallback={<RouteFallback />}><MetaAdsDubaiPage /></Suspense>;

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/performance-marketing-agentur-dubai"} component={DubaiLandingPageRoute} />
      <Route path={"/meta-ads-agentur-dubai"} component={MetaAdsDubaiPageRoute} />
      <Route path={"/llm-ki-optimierung"} component={AiOptimizationPageRoute} />
      <Route path={"/shopify-meta-ads-agentur"} component={ShopifyMetaAdsPageRoute} />
      <Route path={"/light-preview"} component={LightPreviewRoute} />
      <Route path={"/404"} component={NotFoundRoute} />
      <Route component={NotFoundRoute} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <ThemeProvider defaultTheme="dark">
          <Router />
        </ThemeProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
